import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { Container } from "reactstrap";
import "./index.css";
import ApiCaller from "../../../../api/apiCaller";
import Loading from "../../../../components/Loading";
import StoreEdit from "../StoreEdit";
import _ from "lodash";
import StoreInformation from "pages/Store/components/StoreInformation";
import api from "api";
import StoreActions from "pages/Store/components/StoreActions";
import ModalInput from "components/ModalInput";
import t from "utils/Lang";

export default function StoreDetail() {
  const match = useRouteMatch("/store/:store_id");
  const params: any = match?.params;
  const storeId = params?.store_id;
  const [storeStatusMapping, setStoreStatusMapping] = useState<any>({});
  const [financial, setFinancial] = useState<any>();
  const [openReason, setOpenReason] = useState(false);
  const [statusChange, setStatusChange] = useState<any>();
  const [storeData, setStoreData] = useState<any>({
    data: null,
    labels: null,
    loading: true,
    customAttributes: [],
  });
  const toggleReason = () => setOpenReason(!openReason);
  const getStoreStatusMapping = async () => {
    const res = await api.getStoreStatusMapping();
    if (res?.status == "ok") {
      setStoreStatusMapping(res.result);
    }
  };

  const getFinancialPerformance = async () => {
    const res = await api.getFinancialPerformance(storeId);
    if (res.result) {
      setFinancial(res.result);
    }
  };

  useEffect(() => {
    getStoreDetail();
    getStoreStatusMapping();
    getFinancialPerformance();
  }, []);

  const getStoreDetail = async () => {
    const res = await ApiCaller.get(`store/${storeId}`);
    if (res?.result) {
      const resCustomeAttributes = await ApiCaller.get(
        `location_attribute/?q=(filters:!((col:location_type,opr:rel_o_m,value:${res?.result?.location_type?.id})))`
      );
      if (resCustomeAttributes?.result) {
        setStoreData({
          data: res?.result,
          labels: res?._labels,
          loading: false,
          customAttributes: resCustomeAttributes?.result,
        });
      } else {
        setStoreData({
          data: res?.result,
          labels: res?._labels,
          loading: false,
          customAttributes: [],
        });
      }
    } else {
      setStoreData({ ...storeData, ...{ loading: false } });
    }
  };

  const changeStatusApi = async (apiSuffixToCall?: string, reason?: string) => {
    setStoreData({
      ...storeData,
      loading: true,
    });
    const res = await api.changeStoreStatus(storeId, apiSuffixToCall, reason);
    if (res?.result) {
      getStoreDetail();
    } else {
      setStoreData({
        ...storeData,
        ...{ loading: false },
      });
    }
  };

  const changeSiteStatus = async (
    apiSuffixToCall: string,
    isRollBack: boolean
  ) => {
    setStatusChange(apiSuffixToCall);
    if (isRollBack) {
      setOpenReason(true);
    } else {
      changeStatusApi(apiSuffixToCall);
    }
  };

  const onConfirmChangeStatus = (reason: string) => {
    changeStatusApi(statusChange, reason);
    toggleReason();
  };

  if (storeData.loading) return <Loading />;

  return (
    <Container>
      <StoreActions
        buttonData={storeStatusMapping?.[storeData?.data?.status?.code]}
        onClick={(btn) => {
          changeSiteStatus(
            btn.code,
            btn.order_sequence_number <
              storeData?.data?.status?.order_sequence_number
          );
        }}
      />
      <StoreInformation storeData={storeData} />
      <StoreEdit
        {...{
          storeDataProps: storeData,
          storeIdProps: storeId,
          financial,
        }}
      />
      <ModalInput
        isOpen={openReason}
        onConfirm={onConfirmChangeStatus}
        title={t().site_listing__reverse_reason}
        toggle={toggleReason}
        placeholder={t().site_listing__reverse_placeholder}
      />
    </Container>
  );
}
